// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {ReactNode} from 'react';
import cn from 'classnames';

import {use_theme} from '../../../../../hola/pub/settings_ctx';
import Icon_check from '../../../../../hola/pub/img/svg/icon/check.svg';
import {Splash_screen_loader} from '../../splash_screen_loader/splash_screen_loader';
import {Kyc_account} from '../../dashboard/kyc/kyc';

import styles from './payment_form_wrapper.module.less';
import {t_periods} from '../../../types';
import {use_login} from '../../navbar/use_login';

type t_payment_form_wrapper = {
    cls?: string;
    form: ReactNode;
    submitting: boolean;
    total: number;
    period: t_periods;
    purchase_disabled?: boolean;
    need_kyc?: boolean;
};

const PERIOD_TO_TEXT: Record<t_periods, string> = {
    '1m': 'month',
    '1y': 'year',
    '1w': 'week',
    '1d': 'day',
    '3m': 'three months',
};

export const Payment_form_wrapper = ({cls, form, total,
    period, submitting, purchase_disabled, need_kyc = false
}: t_payment_form_wrapper)=>{
    const {theme} = use_theme();
    const {on_login} = use_login();
    return <div className={cn(cls, theme.root, styles.payment_form_wrapper)}>
        <div className={styles.form}>{form}</div>
        {!purchase_disabled &&
        <div className={styles.badge_wrapper}>
            <p className={theme.p5}>
                <span className={styles.badge}>
                    <Icon_check />&nbsp; Your payment is secured and
                    end-to-end encrypted
                </span>
            </p>
        </div>}
        {!purchase_disabled ? <p className={cn(theme.p4, styles.bottom)}>
            Your subscription will automatically renew
            every {PERIOD_TO_TEXT[period]}.
            You will be charged ${total?.toFixed(2)} on each renewal
            until you cancel it via your dashboard. If you cancel,
            previous charges will not be refunded, but you may continue
            to use the service until the end of the term you paid for.
        </p> :
        <div>
            <div className={styles.kyc_container}>
                {need_kyc ?
                  <Kyc_account
                    button_text={'Verify my identity'}
                    show_title_kyc={false}
                    on_login={on_login}
                  />
                :null}
            </div>
            <p className={cn(theme.p4, styles.bottom)}>
                This message appears when our system detects that the IP
                address you're using to make a purchase may be flagged for
                suspicious or fraudulent activity.
                To protect both you and our platform, the purchase was
                temporarily blocked. If you believe this is an error, please
                send us the IP address you were using, and we'll review it
                manually.
                Alternatively, you can try making the purchase using a
                different IP address.
            </p>
        </div>}
        <Splash_screen_loader show={submitting} />
    </div>;
};
